"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyAccountDataTypeToJSON = exports.LoyaltyAccountDataTypeFromJSONTyped = exports.LoyaltyAccountDataTypeFromJSON = exports.LoyaltyAccountDataType = void 0;
/**
 * get all loyalty account data stored in the database (current) or updated with data from the loyalty system provider
 * @export
 * @enum {string}
 */
var LoyaltyAccountDataType;
(function (LoyaltyAccountDataType) {
    LoyaltyAccountDataType["Current"] = "current";
    LoyaltyAccountDataType["AllUpdated"] = "allUpdated";
    LoyaltyAccountDataType["AmountOnlyUpdated"] = "amountOnlyUpdated";
})(LoyaltyAccountDataType = exports.LoyaltyAccountDataType || (exports.LoyaltyAccountDataType = {}));
function LoyaltyAccountDataTypeFromJSON(json) {
    return LoyaltyAccountDataTypeFromJSONTyped(json, false);
}
exports.LoyaltyAccountDataTypeFromJSON = LoyaltyAccountDataTypeFromJSON;
function LoyaltyAccountDataTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.LoyaltyAccountDataTypeFromJSONTyped = LoyaltyAccountDataTypeFromJSONTyped;
function LoyaltyAccountDataTypeToJSON(value) {
    return value;
}
exports.LoyaltyAccountDataTypeToJSON = LoyaltyAccountDataTypeToJSON;
//# sourceMappingURL=LoyaltyAccountDataType.js.map